<template>
  <v-menu
    :close-on-content-click="false"
    v-model="activeMenu"
    max-width="290"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <a href="#" @click.prevent="" v-on="on" class="icon-filter-list">
        <i class="fas fa-filter" :class="{'red--text': isFiltered}"/>
      </a>
    </template>

    <v-card>
      <v-card-text class="scroll-filter-content">
        <v-checkbox
          v-model="isAll"
          :indeterminate="indeterminate"
          label="All"
          hide-details
          @click.stop.prevent="toggleAll"
          class="mt-0 ml-0 checkbox-all"
        ></v-checkbox>

        <v-spacer></v-spacer>
        <v-checkbox
          v-for="item in items"
          :key="item.key"
          :label="item.text"

          :value="item.value"
          v-model="draftSelected"
          hide-details
        ></v-checkbox>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="primary"
          @click.prevent="confirmOk"
          :disabled="isOkButtonDisabled"
        >Ok
        </v-btn>
        <v-btn @click.prevent="confirmCancel" class="black--text">Cancel</v-btn>
      </v-card-actions>
    </v-card>


  </v-menu>
</template>

<script>
import StudyLevelService from '@/services/study-level.service.js';

export default {
  name: "StudyLevelFilterInput",
  props: ['selected'],
  model: {
    prop: 'selected',
    event: 'change',
  },
  data() {
    return {
      activeMenu: false,
      draftSelected: [],
      items: [
        {
          'text': 'Oui',
          'value': 1
        },
        {
          'text': 'Non',
          'value': 0
        }
      ],
    }
  },
  created() {
    const _this = this;

    this.draftSelected = this.items.map(item => item.value);
  }
  ,
  computed: {
    indeterminate() {
      return this.draftSelected.length !== 0 && this.draftSelected.length !== this.items.length;
    }
    ,
    isAll: {
      get() {
        return this.draftSelected.length === this.items.length;
      },
      set() {

      }
    }
    ,
    isOkButtonDisabled() {
      return this.draftSelected.length === 0;
    }
    ,
    isFiltered() {
      if (!this.selected || this.selected.length === 0) {
        return false;
      }

      return this.selected.length !== this.items.length;
    }
    ,
  }
  ,
  methods: {
    toggleAll() {
      // @todo: Fix bug toggle all when click on label.
      if (this.draftSelected.length) {
        this.draftSelected = [];
      }
      else {
        this.draftSelected = this.items.map(item => item.value);
      }
    }
    ,
    confirmOk() {
      if (this.isAll) {
        this.change([]);
      }
      else {
        this.change(this.draftSelected);
      }

      this.activeMenu = false;
    }
    ,
    confirmCancel() {
      this.activeMenu = false;
    }
    ,
    change(value) {
      this.$emit('change', value);
    }
    ,
  }
  ,
  watch: {
    activeMenu(newVal, oldVal) {
      // If close menu, reset draftSelected at selected
      if (newVal && !oldVal) {
        if (!this.selected || this.selected.length === 0) {
          this.draftSelected = this.items.map(item => item.value);
        }
        else {
          this.draftSelected = this.selected;
        }
      }
    }
    ,
  }
  ,
}
</script>

<style scoped>
.scroll-filter-content {
  height: 300px;
  overflow: auto;
}
</style>
